import React, { useState } from "react"
import "react-responsive-modal/styles.css"
import { Modal } from "react-responsive-modal"
import { Link } from "gatsby"
import locations from "../data/locations"

const OrderOnline = () => {
  const [open, setOpen] = useState(false)
  const [openMobile, setOpenMobile] = useState(false)
  const [toast, setToast] = useState(false)
  const [toastTwo, setToastTwo] = useState(false)

  const onOpenModal = () => setOpen(true)
  const onCloseModal = () => setOpen(false)
  const onOpenMobileModal = () => setOpenMobile(true)
  const onCloseMobileModal = () => setOpenMobile(false)
  const onOpenToast = () => setToast(true)
  const onCloseToast = () => {
    setOpen(false)
    setToast(false)
  }
  const onOpenToastTwo = () => setToastTwo(true)
  const onCloseToastTwo = () => {
    setOpen(false)
    setToastTwo(false)
  }

  const [spinner, setSpinner] = useState({
    loading: true,
  })

  const hideSpinner = () => {
    setSpinner({
      loading: false,
    })
  }

    return (
        <div className="order-online">
            <div className="order-online-desktop">
              <button onClick={onOpenModal} aria-haspopup="dialog" aria-expanded={open}>Order Online</button>
              <Modal
                open={open}
                onClose={onCloseModal}
                center
                aria-labelledby="order-modal-title"
                aria-describedby="order-modal-desc"
              >
                  <div className="locations">
                    <h3 id="order-modal-title">Locations</h3>
                    <p id="order-modal-desc" className="sr-only">Select a location to order online</p>
                    {locations.map((location, index) => (
                      <React.Fragment key={location.name}>
                        <a
                          href={location.orderOnlineUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="location-link"
                          aria-label={`Order online from ${location.name} location (opens in new tab)`}
                        >
                          {location.name}
                        </a>
                        {index < locations.length - 1 && <br/>}
                      </React.Fragment>
                    ))}
                  </div>
              </Modal>
            </div>
            <div className="order-online-mobile">
              <button onClick={onOpenMobileModal} aria-haspopup="dialog" aria-expanded={openMobile}>Order Online</button>
              <Modal
                open={openMobile}
                onClose={onCloseMobileModal}
                center
                aria-labelledby="order-modal-mobile-title"
                aria-describedby="order-modal-mobile-desc"
              >
                <div className="locations">
                  <h3 id="order-modal-mobile-title">Locations</h3>
                  <p id="order-modal-mobile-desc" className="sr-only">Select a location to order online</p>
                  {locations.map((location, index) => (
                    <React.Fragment key={location.name}>
                      <a
                        href={location.orderOnlineUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="location-link"
                        aria-label={`Order online from ${location.name} location (opens in new tab)`}
                      >
                        {location.name}
                      </a>
                      {index < locations.length - 1 && <br/>}
                    </React.Fragment>
                  ))}
                </div>
              </Modal>
            </div>
        </div>
    );
};

export default OrderOnline
